import { render, staticRenderFns } from "./DeleteLocationModal.vue?vue&type=template&id=51962ddc&scoped=true&"
import script from "./DeleteLocationModal.vue?vue&type=script&lang=ts&"
export * from "./DeleteLocationModal.vue?vue&type=script&lang=ts&"
import style0 from "./DeleteLocationModal.vue?vue&type=style&index=0&id=51962ddc&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51962ddc",
  null
  
)

export default component.exports